import React from "react";

function DeveloperStats({ stats }) {
  const data = stats || {};

  const items = [
    { label: "Total Games", value: data.totalGames || 0 },
    { label: "Active Games", value: data.activeGames || 0 },
    { label: "Playtesters", value: data.totalPlaytesters || 0 },
    { label: "Feedback", value: data.totalFeedback || 0 },
  ];

  return (
    <div className="dev-metrics">
      {items.map((item) => (
        <div key={item.label} className="dev-metric">
          <p className="dev-metric-label">{item.label}</p>
          <p className="dev-metric-value">{item.value}</p>
        </div>
      ))}
    </div>
  );
}

export default DeveloperStats;
